module.exports = __webpack_public_path__ + "static/continuous-education-a1ddf19585aa95fd63e961f1476faa7b.png";